module.exports = __webpack_public_path__ + "static/flags/BC-94589db8258e43484804964b6ff6cf26.gif";